export default __webpack_public_path__ + "static/media/img20.edac8faf.jpg";